import React, { useEffect } from "react";
import RenderFormItem from "../../../../../components/Forms/FormItems";
import { useDispatch } from "react-redux";
import { postData, putData } from "../../../../../actions/developer";
import { getData } from "../../../../../actions/apiCall";
import { Form, notification } from "antd";
const { useForm } = Form;

const GenralSettings = () => {
    const [selectedLeadType, setSelectedLeadType] = React.useState<string | undefined>(undefined);
    const [form] = useForm();
    const dispatch = useDispatch();

    useEffect(() => {
        getSettingData()
    }, [])

    const updateSetting = async (object) => {
        try {
            const resData = await dispatch(postData('/invoices/settings', object));
            if (resData) {
                notification.success({
                    message: 'Success',
                    description: 'Settings updated successfully',
                });
            } else {
                notification.error({
                    message: 'Error',
                    description: 'Failed to update settings',
                });
            }
        } catch (error) {
            console.error("Error updating settings:", error);
            notification.error({
                message: 'Error',
                description: 'Failed to update settings',
            });
        }
    }

    const getSettingData = async () => {
        try {
            const resData = await dispatch(getData('/invoices/settings'));
            if (resData?.code == 200) {
                setSelectedLeadType(resData?.data?.contractType);
                form.setFieldsValue(resData?.data);
            }
        } catch (error) {
            console.error("Error fetching settings:", error);
        }
    }


    return <div className="bg-white rounded-md p-4">
        <div className="flex justify-between">
            <div className="space-y-4">
                <div className="flex gap-4 items-center">
                    <div>Contract Invoice Type</div>
                    <Form
                        form={form}
                    >
                        <RenderFormItem
                            column={{
                                name: 'contractType',
                                type: 'select',
                                isCombo: true,
                                selectProps: {
                                    allowClear: true,
                                    showSearch: true,
                                    style: {
                                        width: '200px'
                                    },
                                    onChange: (e) => {
                                        updateSetting({ contractType: e });
                                    }
                                }
                            }}
                            combo={[{
                                api: '/leads-types',
                                name: 'contractType',
                                idKey: '_id',
                                render: (text) => text.name
                            }]}
                        />
                    </Form>
                </div>
                <div className="flex gap-4 items-center">
                    <div>Invoice Number</div>
                    <Form
                        form={form}
                    >
                        <RenderFormItem
                            column={{
                                name: 'numberSeries',
                                type: 'select',
                                isCombo: true,
                                selectProps: {
                                    allowClear: true,
                                    showSearch: true,
                                    style: {
                                        width: '200px'
                                    },
                                    onChange: (e) => {
                                        updateSetting({ numberSeries: e });
                                    }
                                }
                            }}
                            combo={[{
                                api: '/invoice-number',
                                name: 'numberSeries',
                                idKey: '_id',
                                render: (text) => text.name
                            }]}
                        />
                    </Form>
                </div>
                <div className="flex gap-4 items-center">
                    <div>Email Template</div>
                    <Form
                        form={form}
                    >
                        <RenderFormItem
                            column={{
                                name: 'mailTemplate',
                                type: 'select',
                                isCombo: true,
                                selectProps: {
                                    allowClear: true,
                                    showSearch: true,
                                    style: {
                                        width: '200px'
                                    },
                                    onChange: (e) => {
                                        updateSetting({ mailTemplate: e });
                                    }
                                }
                            }}
                            combo={[{
                                api: '/cms/emailTemplates',
                                name: 'mailTemplate',
                                idKey: '_id',
                                render: (text) => text.name
                            }]}
                        />
                    </Form>
                </div>
            </div>
        </div>
    </div>
}

export default GenralSettings; 